import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Liftline',
    legalName: 'Liftline Door Co.',
    description: "Liftline Door Co. repairs and installs garage doors across the Riverton metro: same-day spring, opener and track repairs, new doors fitted in a day, and a written price before work starts.",
    url: getOrigin(),
    ogImage: 'https://liftline.cdn.modulify.website/brand/og-image.png',
    phone: '(555) 555-0148',
    phoneHref: 'tel:5555550148',
    smsHref: 'sms:5555550148',
    address: '418 Foundry Street, Riverton',
    hours: 'Mon–Sat 8 AM–6 PM',
    emergencyHours: 'Emergency line until 10 PM',
    emergencyUntil: '10 PM',
    license: 'License #GD-004417',
    insured: 'Insured to $2M',
    founded: 2011,
    region: 'Riverton metro'
}

export const QUOTE_PATH = '/request-service'

export const mainNav: NavLink[] = [
    { label: 'Services', href: '/services' },
    { label: 'New Doors', href: '/new-doors' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Projects', href: '/projects' },
    { label: 'Service Areas', href: '/service-areas' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' }
]

export const footerNav: { title: string, links: NavLink[] }[] = [
    {
        title: 'Services',
        links: [
            { label: 'Emergency repair', href: '/services/emergency-repair' },
            { label: 'Broken springs', href: '/services/broken-spring-repair' },
            { label: 'Openers & smart garage', href: '/services/openers-smart-garage' },
            { label: 'Off-track & cables', href: '/services/off-track-cable-repair' },
            { label: 'Panel replacement', href: '/services/panel-replacement' },
            { label: 'Commercial doors', href: '/services/commercial-doors' }
        ]
    },
    {
        title: 'Explore',
        links: [
            { label: 'New doors', href: '/new-doors' },
            { label: 'Pricing & financing', href: '/pricing' },
            { label: 'Projects', href: '/projects' },
            { label: 'Service areas', href: '/service-areas' },
            { label: 'Tune-up & maintenance', href: '/services/tune-up-maintenance' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'About', href: '/about' },
            { label: 'Reviews', href: '/about#reviews' },
            { label: 'Contact', href: '/contact' },
            { label: 'Request service', href: QUOTE_PATH },
            { label: 'Privacy', href: '/privacy' },
            { label: 'Terms', href: '/terms' }
        ]
    }
]
